module.exports = __webpack_public_path__ + "img/ic24Name.ee037074.svg";